// src/main.js
import App from './App.svelte';
import './styles/tokens.css';  // First, so variables are available
import './styles/app.css';     // Then global styles
// Initialize theme from localStorage or system preference
const savedTheme = localStorage.getItem('theme')
  || (window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light');
// Apply theme attribute to root element
document.documentElement.setAttribute('data-theme', savedTheme);

const app = new App({
  target: document.getElementById('app'),
});

export default app;
